module.exports = __webpack_public_path__ + "media/images/sp/site_navigation/icon_access-ab50c63072b880891075a59e88477636.svg";